export function isValidEmail(email) {
  const pattern = /(.+)@(.+)\.(.{2,})/
  return new RegExp(pattern).test(email)
}
